/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2025. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2025. Todos los derechos reservados.
 */

import {InjectionToken} from '@angular/core';

export const DEFAULT_DIAL_CODE = new InjectionToken<string>('DEFAULT_DIAL_CODE');
